// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3PTx9","scoreGained":"Header_scoreGained__kGeFx","moveUpAndFade":"Header_moveUpAndFade__1S0dI"};